/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InvoiceChallengeType } from "./InvoiceChallengeType";
import {
  InvoiceChallengeTypeFromJSON,
  InvoiceChallengeTypeFromJSONTyped,
  InvoiceChallengeTypeToJSON,
  InvoiceChallengeTypeToJSONTyped,
} from "./InvoiceChallengeType";
import type { BulkChallengeAudit } from "./BulkChallengeAudit";
import {
  BulkChallengeAuditFromJSON,
  BulkChallengeAuditFromJSONTyped,
  BulkChallengeAuditToJSON,
  BulkChallengeAuditToJSONTyped,
} from "./BulkChallengeAudit";
import type { InvoiceChallengeMode } from "./InvoiceChallengeMode";
import {
  InvoiceChallengeModeFromJSON,
  InvoiceChallengeModeFromJSONTyped,
  InvoiceChallengeModeToJSON,
  InvoiceChallengeModeToJSONTyped,
} from "./InvoiceChallengeMode";

/**
 *
 * @export
 * @interface BulkCarrierInvoiceChallengeRequest
 */
export interface BulkCarrierInvoiceChallengeRequest {
  /**
   *
   * @type {Array<BulkChallengeAudit>}
   * @memberof BulkCarrierInvoiceChallengeRequest
   */
  audits: Array<BulkChallengeAudit>;
  /**
   *
   * @type {InvoiceChallengeType}
   * @memberof BulkCarrierInvoiceChallengeRequest
   */
  invoiceChallengeType: InvoiceChallengeType;
  /**
   *
   * @type {InvoiceChallengeMode}
   * @memberof BulkCarrierInvoiceChallengeRequest
   */
  mode: InvoiceChallengeMode;
  /**
   *
   * @type {string}
   * @memberof BulkCarrierInvoiceChallengeRequest
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof BulkCarrierInvoiceChallengeRequest
   */
  bodyMarkdown: string;
  /**
   *
   * @type {string}
   * @memberof BulkCarrierInvoiceChallengeRequest
   */
  introMarkdown?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof BulkCarrierInvoiceChallengeRequest
   */
  includeCarrierInvoiceAsAttachment: boolean;
  /**
   *
   * @type {string}
   * @memberof BulkCarrierInvoiceChallengeRequest
   */
  supportAgentFirstName: string;
  /**
   *
   * @type {string}
   * @memberof BulkCarrierInvoiceChallengeRequest
   */
  supportAgentLastName: string;
  /**
   *
   * @type {string}
   * @memberof BulkCarrierInvoiceChallengeRequest
   */
  supportAgentDepartment?: string | null;
}

/**
 * Check if a given object implements the BulkCarrierInvoiceChallengeRequest interface.
 */
export function instanceOfBulkCarrierInvoiceChallengeRequest(
  value: object,
): value is BulkCarrierInvoiceChallengeRequest {
  if (!("audits" in value) || value["audits"] === undefined) return false;
  if (
    !("invoiceChallengeType" in value) ||
    value["invoiceChallengeType"] === undefined
  )
    return false;
  if (!("mode" in value) || value["mode"] === undefined) return false;
  if (!("subject" in value) || value["subject"] === undefined) return false;
  if (!("bodyMarkdown" in value) || value["bodyMarkdown"] === undefined)
    return false;
  if (
    !("includeCarrierInvoiceAsAttachment" in value) ||
    value["includeCarrierInvoiceAsAttachment"] === undefined
  )
    return false;
  if (
    !("supportAgentFirstName" in value) ||
    value["supportAgentFirstName"] === undefined
  )
    return false;
  if (
    !("supportAgentLastName" in value) ||
    value["supportAgentLastName"] === undefined
  )
    return false;
  return true;
}

export function BulkCarrierInvoiceChallengeRequestFromJSON(
  json: any,
): BulkCarrierInvoiceChallengeRequest {
  return BulkCarrierInvoiceChallengeRequestFromJSONTyped(json, false);
}

export function BulkCarrierInvoiceChallengeRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BulkCarrierInvoiceChallengeRequest {
  if (json == null) {
    return json;
  }
  return {
    audits: (json["audits"] as Array<any>).map(BulkChallengeAuditFromJSON),
    invoiceChallengeType: InvoiceChallengeTypeFromJSON(
      json["invoiceChallengeType"],
    ),
    mode: InvoiceChallengeModeFromJSON(json["mode"]),
    subject: json["subject"],
    bodyMarkdown: json["bodyMarkdown"],
    introMarkdown:
      json["introMarkdown"] == null ? undefined : json["introMarkdown"],
    includeCarrierInvoiceAsAttachment:
      json["includeCarrierInvoiceAsAttachment"],
    supportAgentFirstName: json["supportAgentFirstName"],
    supportAgentLastName: json["supportAgentLastName"],
    supportAgentDepartment:
      json["supportAgentDepartment"] == null
        ? undefined
        : json["supportAgentDepartment"],
  };
}

export function BulkCarrierInvoiceChallengeRequestToJSON(
  json: any,
): BulkCarrierInvoiceChallengeRequest {
  return BulkCarrierInvoiceChallengeRequestToJSONTyped(json, false);
}

export function BulkCarrierInvoiceChallengeRequestToJSONTyped(
  value?: BulkCarrierInvoiceChallengeRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    audits: (value["audits"] as Array<any>).map(BulkChallengeAuditToJSON),
    invoiceChallengeType: InvoiceChallengeTypeToJSON(
      value["invoiceChallengeType"],
    ),
    mode: InvoiceChallengeModeToJSON(value["mode"]),
    subject: value["subject"],
    bodyMarkdown: value["bodyMarkdown"],
    introMarkdown: value["introMarkdown"],
    includeCarrierInvoiceAsAttachment:
      value["includeCarrierInvoiceAsAttachment"],
    supportAgentFirstName: value["supportAgentFirstName"],
    supportAgentLastName: value["supportAgentLastName"],
    supportAgentDepartment: value["supportAgentDepartment"],
  };
}
